import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=58a74c3d&scoped=true&"
import script from "./Suggestion.vue?vue&type=script&lang=ts&"
export * from "./Suggestion.vue?vue&type=script&lang=ts&"
import style0 from "./Suggestion.vue?vue&type=style&index=0&id=58a74c3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a74c3d",
  null
  
)

export default component.exports